import ApiClient from '@/api/ApiClient';

const client = new ApiClient('tempworker/specificavailability');

class SpecificAvailabilityApiTempWorker {

	static add (addSpecificAvailabilityModel: IAddSpecificAvailabilityModel) {
		return client.post<ISpecificAvailabilityModel>('', addSpecificAvailabilityModel);
	}

	static update (id: number, updateSpecificAvailabilityModel: IUpdateSpecificAvailabilityModel) {
		return client.put<ISpecificAvailabilityModel>(id.toString(), updateSpecificAvailabilityModel);
	}

	static delete (id: number) {
		return client.delete<void>(id.toString());
	}

	static get (id: number) {
		return client.get<ISpecificAvailabilityModel>(id.toString());
	}

	static list () {
		return client.get<ISpecificAvailabilityModel[]>('');
	}
}

export default SpecificAvailabilityApiTempWorker;
